<ag-grid-angular class="ag-theme-balham ag-grid-kpi ag-grid-scenarii" [gridOptions]="gridOptions"></ag-grid-angular>
@if (canEdit) {
  <button (click)="newScenario()" [nbSpinner]="loadingNewScenario" [disabled]="loadingNewScenario" class="mt-2">
    <fa-icon icon="plus"></fa-icon> <span class="create-scenario">{{  "Create new scenario" | translate }}</span>
  </button>
}
